import { Navigate, useLocation } from 'react-router';
import { ASSISTANT_ME_PATH, type MeTab } from './tabs';

/** `CONNECTIONS_SECTION_ID`, written out: this rides in the main chunk, the connections section does not. */
const OLD_CONNECTIONS_HASH = '#connections';

/**
 * An old address of the assistant's settings (`/settings/assistant`, its memory page) sent to its tab of
 * `/assistant/me` (S8 §9, D85). The rest of the query (an OAuth return's `ext_error`) and the hash are kept: a stored
 * OAuth `return_to`, a bookmark or an old notice still lands where it meant. `#connections` was the connections card
 * of the old page, so it opens "Kết nối".
 */
export function RedirectTo({ tab }: { tab: MeTab }) {
  const { search, hash } = useLocation();
  const target: MeTab = hash === OLD_CONNECTIONS_HASH ? 'ket-noi' : tab;
  const params = new URLSearchParams([['tab', target]]);
  new URLSearchParams(search).forEach((value, key) => { if (key !== 'tab') params.append(key, value); });
  return <Navigate to={{ pathname: ASSISTANT_ME_PATH, search: `?${params.toString()}`, hash }} replace />;
}
